import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ExternalLink } from '../assets/icons/external.svg';
import { ReactComponent as UserIcon } from '../assets/icons/user.svg';
import { ReactComponent as LocationIcon } from '../assets/icons/location.svg';
import { ReactComponent as SocialIcon } from '../assets/icons/social.svg';
import ManticoreImage from "../assets/images/manticore.png";


function App() {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const listItems = [
    {
      icon: UserIcon,
      text: t('default.list.contactsAndProfiles')
    },
    {
      icon: LocationIcon,
      text: t('default.list.locationsAndActivities')
    },
    {
      icon: SocialIcon,
      text: t('default.list.mediaAndPublic')
    }
  ];


  useEffect(() => {
    // Відправляємо запит на файл у папці public
    fetch(`${process.env.PUBLIC_URL}/botname.txt`)
        .then((response) => response.text())
        .then((data) => setText(data))
        .catch((error) => console.error("Error loading text:", error));
  }, []);
  console.log(text, 'text')
  const handleOpenBot = () => {
    window.open(
        `tg://resolve?domain=${text}`,
        "_blank"
    );
  }

  return (
    <div className="wrapper">
      <div className="container">
        <div className="content">
          <h1>Manticore Telegram Bot</h1>
          <div className="text">
            <p>{t('default.subtitle')}</p>
            <ul className="list">
              {listItems?.map(({ icon: Icon, text }, index) => (
                <li key={index}>
                  {Icon && <Icon />}
                  {text}
                </li>
              ))}
            </ul>
          </div>
          <button className="button" onClick={handleOpenBot}>
            {t('default.buttonText')} <ExternalLink />
          </button>
        </div>

        <img src={ManticoreImage} alt="manticore" />
      </div>
    </div>
  );
}

export default App;
